import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { IconMonogram } from './ui/Icons';
export function LoadingScreen() {
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1200);
    return () => clearTimeout(timer);
  }, []);
  return <AnimatePresence data-id="element-175">
      {isLoading && <motion.div initial={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.6,
      ease: 'easeInOut'
    }} className="fixed inset-0 z-50 flex items-center justify-center bg-brand-cream" data-id="element-176">
          <motion.div initial={{
        scale: 0.9,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="flex flex-col items-center text-brand-mocha" data-id="element-177">
            <IconMonogram className="w-24 h-24 mb-4" data-id="element-178" />
            <motion.div initial={{
          width: 0
        }} animate={{
          width: '100%'
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeInOut'
        }} className="h-[1px] bg-brand-gold/50 w-full max-w-[100px]" data-id="element-179" />
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}